import React from 'react';
import { useSelector } from 'react-redux';

import { isAuthenticating } from 'src/modules/auth/selectors/authenticationSelectors';

import { Footer } from './Footer';
import * as S from './styles';

/**
 * This layout is used for pages that are not authenticated,
 * it shows our standard footer with contact information.
 */
export const UnauthenticatedLayout: React.FC = props => {
    const authenticating = useSelector(isAuthenticating);

    return (
        <>
            <S.Content data-testid="appContent">{props.children}</S.Content>
            {!authenticating ? <Footer /> : null}
        </>
    );
};
